<template>
  <b-col class="animated fadeIn">
    <b-card>
      <div slot="header">
        <div>
          <b-col>
            <b-row>
              <b-col sm="6">
                <i class="fa fa-bars"></i> {{$t('str.forum-contact-request-report')}}
              </b-col>
              <b-col sm="6"></b-col>
            </b-row>
          </b-col>
        </div>

        <div>
          <b-col sm="12" style="margin-top:10px;">
            <b-row>
              <b-col sm="4">
                <b-row>
                  <b-col>
                    {{ $t('str.date-range') }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <flat-pickr :config="dateConfig" v-model="dateRange" id="date_range" class="form-control"
                      name="date_range"></flat-pickr>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="4">
                <b-row>
                  <b-col>
                    {{ $t('str.country') }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-select id="country_id" name="country_id" :plain="true" v-model="countryId"
                      style="height:100%;" :key="countrySelectKey">
                      <option value="">{{$t('str.all')}}</option>
                      <option v-for="(c, index) in countrySelect" :value="c.value" :key="index">{{c.text}}</option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="4">
                <b-row>
                  <b-col>
                    {{ $t('str.keyword') }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword" @keyup.enter="getData()">
                      </b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-row>
                  <b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">{{$t('str.office')}}</template>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">
                      <b-form-select id="office_id" name="office_id" :plain="true" v-model="officeId"
                        style="height:100%;" @change="() => {
                          getCountrySelect()
                          rerenderCountrySelect()
                        }">
                        <option value="">{{$t('str.all')}}</option>
                        <option v-for="(c, index) in officeSelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </template>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="6">
                <b-row>
                </b-row>
                <b-row style="height:100%">
                  <b-col style="display:flex; align-items:end; justify-content:flex-end;">
                    <b-button type="button" variant="secondary" @click="resetFilter()" class="mr-1">{{ $t('str.reset-filter') }}</b-button>
                    <b-button type="submit" variant="primary" @click="getData()" class="mr-1">{{ $t('str.search') }}</b-button>
                    <b-button type="submit" variant="secondary" @click="exportFile()"
                      :disabled="submittedExport"><i v-if="submittedExport"
                      class="fa fa-spinner fa-spin"></i>{{ $t('str.export') }}</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </div>

      <div>
        <b-col>
          <p :class="{ 'text-center': true, 'd-none': data.length }" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{ 'd-none': !data.length }" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="data" :fields="fields" :current-page="currentPage">
          </b-table>
          <nav :class="{ 'd-none': !data.length }">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-col>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'ForumContactRequest',
  components: {
    'paging': Pagination,
    'buttons': Buttons,
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      data: [],
      fields: [
        { key: 'no', label: 'No.' },
        { key: 'subject', label: 'Subject', sortable: true },
        { key: 'message', label: 'Message', sortable: true },
        { key: 'from_user', label: 'From', sortable: true },
        { key: 'to_user', label: 'To', sortable: true },
        { key: 'country', label: 'Country', sortable: true },
      ],
      currentPage: 1,
      totalPage: 0,
      keyword: '',
      countrySelect: [],
      officeSelect: [],
      countryId: '',
      officeId: '',
      dateRange: (moment().subtract(1, 'months').format('YYYY-MM-DD'))+' - '+(moment().format('YYYY-MM-DD')),
      dateConfig: {
        locale: {rangeSeparator: ' - '},
        mode: 'range',
        altInput: true,
        altFormat: 'd M Y',
        dateFormat: 'Y-m-d',
        defaultDate: [(moment().subtract(1, 'months').format('YYYY-MM-DD')), (moment().format('YYYY-MM-DD'))]
      },
      countrySelectKey: 0,
      submittedExport: false,
    }
  },
  methods: {
    async getCountrySelect() {
      this.$auth.checkSession()
      try {
        let trail = ''
        if (this.officeId != '') {
          trail += `?office=${this.officeId}`
        }

        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Country/ByUserOfficeSelect${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        this.countrySelect = []
        for (let i = 0; i < cData.length; i++) {
          this.countrySelect.push({'value': cData[i].id, 'text': cData[i].name})
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        this.officeSelect = []
        for (let i = 0; i < cData.length; i++) {
          this.officeSelect.push({'value': cData[i].id, 'text': cData[i].name})
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getData() {
      this.$auth.checkSession()

      let officerOffice = this.$auth.session.get('office')
      if (officerOffice) this.officeId = officerOffice

      let dates = this.dateRange.split(' - ')

      let trail = `?start_date=${dates[0]}&end_date=${dates[1]}`
      if (this.countryId != '') trail += `&country=${this.countryId}`
      if (this.officeId != '') trail += `&office=${this.officeId}`
      if (this.keyword != '') trail += `&keyword=${this.keyword}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Report/ForumDm${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.data = getData.data.data
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.countryId = ''
      this.officeId = ''
      this.dateRange = (moment().subtract(1, 'months').format('YYYY-MM-DD'))+' - '+(moment().format('YYYY-MM-DD'))
      this.getCountrySelect()
      this.getOfficeSelect()
      this.getData()
    },
    rerenderCountrySelect() {
      this.countrySelectKey += 1
      this.countryId = ''
    },
    async exportFile() {
      this.exportFileSuccess = ''
      this.exportFileError = ''
      this.$auth.checkSession()

      let dates = this.dateRange.split(' - ')

      let trail = `?start_date=${dates[0]}&end_date=${dates[1]}`
      if (this.countryId != '') trail += `&country=${this.countryId}`
      if (this.officeId != '') trail += `&office=${this.officeId}`
      if (this.keyword != '') trail += `&keyword=${this.keyword}`

      let url = `${this.$helper.envi.VUE_APP_API_URL}/Export/ForumDm` + trail

      try {
        this.submittedExport = true
        let file = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        if (file.data) {
          window.open(this.$helper.envi.VUE_APP_API_URL + '/' + file.data)
        }

        let delUrl = this.$helper.envi.VUE_APP_API_URL + '/Export/DownloadFile/ForumDm'
        let delAuth = this.$auth.session.get().passport
        let timer = setInterval(async function () {
          if (open.closed) {
            clearInterval(timer)
            await axios.get(delUrl, {
              headers: { 'Authorization': `Bearer ${delAuth}` }
            })
          }
        }, 1000)
      } catch (e) { console.log(e) }
      this.submittedExport = false
    },
  },
  created() {
    this.getCountrySelect()
    this.getOfficeSelect()
    this.getData()
  }
}
</script>